import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=0b1b807c"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src117016002/src/console/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b1b807c')) {
      api.createRecord('0b1b807c', component.options)
    } else {
      api.reload('0b1b807c', component.options)
    }
    module.hot.accept("./Checkbox.vue?vue&type=template&id=0b1b807c", function () {
      api.rerender('0b1b807c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MainContent/Checkbox.vue"
export default component.exports